import React, { useState, useEffect, useContext } from 'react';
import "../../../ui-styles/list/PastAppointmentDetails.css";
import "../../../ui-styles/sliders/RightChildSlider.css";
import "../../../ui-styles/filterList/filterInput.css";
import IconSelect from "../../../lib/ui/iconSelect/iconSelect";
import PatientReports from "./PatientReports";
import { LangCtx } from "../../../lib/context";
import { pastAppointments } from '../../../actions/appointment';
import PatientPastAppointmentItem from './PatientPastAppointmentItem';
import Loader from '../../../lib/ui/loader/Loader';
import PrescriptionSlide from '../../conference/components/PrescriptionSlide';


// const filterList = [{ value: "Last Month", label: "Last Month" },{ value: "lastVisit", label: "Last Visit" }, { value: "Last Week", label: "Last Week" }, { value: "Last Year", label: "Last Year" }, { value: "All", label: "All" },]
const filterList = [{ value: "Last Month", label: "Last Month" }, { value: "Last Week", label: "Last Week" }, { value: "Last Year", label: "Last Year" }, { value: "All", label: "All" }]


const PatientPastAppointments = (props) => {
    const { l } = useContext(LangCtx);
    const [reports, setReports] = useState(false);
    const [pscpnSlide, setPscpnSlide] = useState(false);
    const [pastAppointmentId, setPastAppointmentId] = useState(null);
    const [loading, setLoading] = useState(false)
    const [filtList, setFiltList] = React.useState('');
    const d = new Date()
    const [body, setBody] = useState({
        to: new Date().valueOf(),
        from: new Date(d.setMonth(d.getMonth() - 1)).valueOf(),
        doctorId: props.data.doctorId,
        apptId: props.data.appointmentId
    })
    const [appointments, setAppointments] = useState([]);

    useEffect(
        () => {
            if (props.data && props.data.patientId) {
                loadPastAppointemnts(props.data.patientId, body);
            }
        }, [props.data.patientId, body])

    const loadPastAppointemnts = (id, _body) => {
        setLoading(true)
        pastAppointments(id, _body).then((res) => {
           
            if (res && res.status) {
                setLoading(false)
                setAppointments(res.data);
            }
        }).catch(err => {
            console.log(err.response)
            setLoading(false);
        })
    }

    useEffect(
        () => {
            if (filtList !== "") {
                let body = {
                    to: new Date().valueOf(),
                    from: new Date().setMonth(new Date().getMonth() - 1).valueOf(),
                    doctorId: props.data.doctorId,
                    apptId: props.data.appointmentId
                }

                if (filtList === "Last Week") {
                    body.from = new Date().setDate(new Date().getDate() - 7).valueOf()
                }
                else if (filtList === "Last Month") {
                    body.from = new Date().setMonth(new Date().getMonth() - 1).valueOf()
                }
                else if (filtList === "Last Year") {
                    body.from = new Date().setFullYear(new Date().getFullYear() - 1).valueOf()
                }
                else if (filtList === "All") {
                    body.from = new Date().setFullYear(new Date().getFullYear() - 1).valueOf()
                }
                setBody(body)
            }
        }, [filtList])

    const handlePscpnSlide = (aptData) => {
        setPastAppointmentId(aptData);
        setPscpnSlide(prevState => !prevState);
    }

    const handleReports = () => {
        setReports(preState => !preState);
    }

    const handleChange = (e) => {
        setFiltList(e.target.value);
    };

    return (
        <div className="listContainer">
            <div className="filterRowBlock">
                <div className="labelTxtBlock">
                    <span>{l.filter}</span>
                </div>
                <IconSelect className="filterSelect"
                    placeholder="Filter"
                    items={filterList}
                    value={filtList}
                    onChange={handleChange}
                    src="/images/icons/filter.png"
                />
            </div>
            <div className="pstDateRow">
                <div className="pstDateBox">
                    <small>{new Date(body.from).toDateString()}</small>
                </div>
            </div>
            <div className="padtlsGroup">
                {loading ? <Loader /> : appointments.map(item =>
                    <PatientPastAppointmentItem data={item} handlePscpnSlide={handlePscpnSlide} handleReports={handleReports} />
                )}
            </div>
            {pscpnSlide && <PrescriptionSlide type="past" openSlide={pscpnSlide} closePresc={handlePscpnSlide} data={pastAppointmentId} />}
            {/* {pscpnSlide && <PatientPrescription pscpnSlide={pscpnSlide} handlePscpnSlide={handlePscpnSlide} pastAppointmentId={pastAppointmentId} data={props.data} />} */}
            {reports && <PatientReports reports={reports} handleReports={handleReports} data={props.data}  />}
        </div>
    )
}
export default PatientPastAppointments;
